breakpointValue = '1000';

let mediaQuery = window.matchMedia(`(max-width: ${breakpointValue}px)`);

function handleMobileMenu(mediaQuery) {
    if (mediaQuery.matches) {
        // Solo se ejecuta si el ancho es menor a 1000px
        let mobileMenuContainer = document.querySelector('.wp-block-navigation__responsive-container');
        
        // Asegúrate de que el contenedor exista antes de seguir
        if (!mobileMenuContainer) return;
        
        let allMobileMenuLinks = mobileMenuContainer.querySelectorAll('ul li a');

        allMobileMenuLinks.forEach(link => {
            link.addEventListener('click', () => {
                mobileMenuContainer.classList.toggle('is-menu-open');
            });
        });
    }
}

// Llamada inicial
handleMobileMenu(mediaQuery);

// Escucha por cambios en el tamaño de la ventana
mediaQuery.addEventListener("change", handleMobileMenu);


